module.exports = __webpack_public_path__ + "static/media/mdi_arrow_downward.b0964e0b.svg";